/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 722:
/***/ (() => {

        class VariantSelection extends HTMLElement {
          static get observedAttributes() {
            return ['variant'];
          }

          constructor() {
            super();
            this._loaded = false;
            this._productFetcher = Promise.resolve(false);

            this._onMainElChange = event => {
              this.variant = event.currentTarget.value;
            };

            const mainInputEl = this.querySelector('input[data-variants]');
            this._mainEl = mainInputEl || this.querySelector('select[data-variants]');
          }

          set variant(value) {
            if (value) {
              this.setAttribute('variant', value);
            } else {
              this.removeAttribute('variant');
            }
          }

          get variant() {
            return this.getAttribute('variant');
          }

          connectedCallback() {
            this._productFetcher = this._fetchProduct();
            const mainInputEl = this.querySelector('input[data-variants]');
            this._mainEl = mainInputEl || this.querySelector('select[data-variants]');

            this._mainEl.addEventListener('change', this._onMainElChange);

            this.variant = this._mainEl.value;
          }

          disconnectedCallback() {
            this._mainEl.removeEventListener('change', this._onMainElChange);

            this._mainEl = null;
          }

          attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue === newValue) return;

            switch (name) {
              case 'variant':
                this._changeVariant(newValue);

                break;
            }
          }

          getProduct() {
            return this._loaded ? Promise.resolve(this._product) : this._productFetcher;
          }

          getVariant() {
            return this.getProduct().then(product => product ? product.variants.find(v => v.id.toString() === this.variant) || false : false).catch(() => false);
          }

          getState() {
            return this.getVariant().then(variant => variant ? 'selected' : this.getAttribute('variant'));
          }

          _changeVariant(value) {
            this._dispatchEvent(value).then(() => {
              this._mainEl.value = value;
            });
          }

          _fetchProduct() {
            return fetch(this.getAttribute('product-url')).then(response => response.json()).then(product => {
              this._product = product;
              return product;
            }).catch(() => {
              this._product = null;
            }).finally(() => {
              this._loaded = true;
            });
          }

          _dispatchEvent(value) {
            return this.getProduct().then(product => {
              const variant = product ? product.variants.find(v => v.id.toString() === value) || false : false;
              const state = variant ? 'selected' : value;
              const event = new CustomEvent('variant-change', {
                detail: {
                  product,
                  variant,
                  state
                }
              });
              this.dispatchEvent(event);
            });
          }

        }

        const valueElementType = {
          select: 'option',
          radio: 'input[type="radio"]'
        };

        function setSelectedOptions(selectOptions, radioOptions, selectedOptions) {
          selectOptions.forEach(({
            option
          }) => {
            option.value = selectedOptions[parseInt(option.dataset.variantOptionIndex, 10)];
          });
          radioOptions.forEach(({
            values
          }) => {
            values.forEach(value => {
              value.checked = value.value === selectedOptions[parseInt(value.dataset.variantOptionValueIndex, 10)];
            });
          });
        }

        function getOptions(optionsEls) {
          const select = [];
          const radio = [];

          for (let i = 0; i < optionsEls.length; i++) {
            const optionEl = optionsEls[i];
            const wrappers = optionEl.matches('[data-variant-option-value-wrapper]') ? [optionEl] : Array.prototype.slice.call(optionEl.querySelectorAll('[data-variant-option-value-wrapper]'));
            const values = optionEl.matches('[data-variant-option-value]') ? [optionEl] : Array.prototype.slice.call(optionEl.querySelectorAll('[data-variant-option-value]'));
            if (!values.length) break;
            const option = {
              option: optionEl,
              wrappers,
              values
            };

            if (values[0].matches(valueElementType.select)) {
              select.push(option);
            } else if (values[0].matches(valueElementType.radio)) {
              radio.push(option);
            }
          }

          return {
            select,
            radio
          };
        }

        function getSelectedOptions(product, selectOptions, radioOptions) {
          const options = product.options.map(() => 'not-selected');
          selectOptions.forEach(({
            option
          }) => {
            if (option.value !== 'not-selected') {
              options[parseInt(option.dataset.variantOptionIndex, 10)] = option.value;
            }
          });
          radioOptions.forEach(({
            values
          }) => {
            values.forEach(value => {
              if (value.checked) {
                options[parseInt(value.dataset.variantOptionValueIndex, 10)] = value.value;
              }
            });
          });
          return options;
        }

        function getVariantFromSelectedOptions(variants, selectedOptions) {
          for (let i = 0; i < variants.length; i++) {
            const variant = variants[i];
            const isVariant = variant.options.every((option, index) => option === selectedOptions[index]);
            if (isVariant) return variant; // We found the variant
          }

          return false;
        }

        function _getVariant(variants, options) {
          return variants.find(variant => variant.options.every((option, index) => option === options[index]));
        }

        function _setOptionsMap(product, selectedOptions, optionsMap, option1, option2 = null, option3 = null) {
          const updatedOptionsMap = {
            ...optionsMap
          };
          const options = [option1, option2, option3].filter(option => !!option);

          const variant = _getVariant(product.variants, options);

          const variantOptionMatches = options.filter((option, index) => option === selectedOptions[index]).length;
          const isCurrentVariant = variantOptionMatches === product.options.length;
          const isNeighbor = variantOptionMatches === product.options.length - 1;

          for (let i = 0; i < options.length; i++) {
            const option = options[i];

            if (option) {
              let {
                setByCurrentVariant,
                setByNeighbor,
                accessible,
                available
              } = optionsMap[i][option];

              if (variant) {
                accessible = variant.available || accessible; // The current variant is always
                // the priority for option availability

                if (isCurrentVariant) {
                  setByCurrentVariant = true;
                  ({
                    available
                  } = variant);
                } else if (!setByCurrentVariant && isNeighbor) {
                  // If the variant is a neighbor
                  // And the option doesn't belong to the variant
                  // Use its availability information for the option
                  // If multiple neighbors exist, prefer true
                  available = setByNeighbor ? available || variant.available : variant.available;
                  setByNeighbor = true;
                }
              } else if (isCurrentVariant) {
                // Catch case where current variant doesn't exist
                // Ensure availability is false
                setByCurrentVariant = true;
                available = false;
              } else if (!setByCurrentVariant && isNeighbor) {
                // Catch case where neighbor doesn't exist
                // Ensure availability is false
                // If multiple neighbors exist, prefer true
                available = setByNeighbor ? available : false;
                setByNeighbor = true;
              } // If the option isn't set by either
              // the current variant or a neighbor
              // default to general accessibility


              if (!setByCurrentVariant && !setByNeighbor) {
                available = accessible;
              }

              updatedOptionsMap[i][option] = {
                setByCurrentVariant,
                setByNeighbor,
                accessible,
                available
              };
            }
          }

          return updatedOptionsMap;
        }

        function getOptionsAccessibility(product, selectedOptions) {
          let optionsMap = product.options.map(() => ({}));

          for (let i = 0; i < product.options.length; i++) {
            for (let j = 0; j < product.variants.length; j++) {
              const variant = product.variants[j];
              const option = variant.options[i];
              optionsMap[i][option] = {
                setByCurrentVariant: false,
                setByNeighbor: false,
                accessible: false,
                available: false
              };
            }
          }

          const option1Values = optionsMap.length >= 1 ? Object.keys(optionsMap[0]) : [];
          const option2Values = optionsMap.length >= 2 ? Object.keys(optionsMap[1]) : [];
          const option3Values = optionsMap.length >= 3 ? Object.keys(optionsMap[2]) : [];
          option1Values.forEach(option1Value => {
            option2Values.forEach(option2Value => {
              option3Values.forEach(option3Value => {
                optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value, option2Value, option3Value);
              });

              if (!option3Values.length) {
                optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value, option2Value);
              }
            });

            if (!option2Values.length) {
              optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value);
            }
          });
          return optionsMap;
        }

        function updateOptions(product, selectOptions, radioOptions, selectedOptions, disableUnavailableOptions, removeUnavailableOptions) {
          const options = [...selectOptions, ...radioOptions];

          if (options.length === 0) {
            return;
          }

          const optionsAccessibility = getOptionsAccessibility(product, selectedOptions); // Iterate over each option type

          for (let i = 0; i < product.options.length; i++) {
            // Corresponding select dropdown, if it exists
            const optionValues = options.find(({
              option
            }) => {
              if (parseInt(option.dataset.variantOptionIndex, 10) === i) {
                return true;
              }

              return false;
            });

            if (optionValues) {
              const fragment = document.createDocumentFragment();
              const {
                option,
                wrappers,
                values
              } = optionValues;

              for (let j = values.length - 1; j >= 0; j--) {
                const wrapper = wrappers[j];
                const optionValue = values[j];
                const {
                  value
                } = optionValue;
                const {
                  available
                } = value in optionsAccessibility[i] ? optionsAccessibility[i][value] : false;
                const {
                  accessible
                } = value in optionsAccessibility[i] ? optionsAccessibility[i][value] : false;
                const isChooseOption = value === 'not-selected'; // Option element to indicate unchosen option
                // Disable unavailable options

                optionValue.disabled = isChooseOption || disableUnavailableOptions && !accessible;
                optionValue.dataset.variantOptionAccessible = accessible;
                optionValue.dataset.variantOptionAvailable = available;

                if (!removeUnavailableOptions || accessible || isChooseOption) {
                  fragment.insertBefore(wrapper, fragment.firstElementChild);
                }
              }

              option.innerHTML = '';
              option.appendChild(fragment);
              const chosenValue = values.find(value => value.selected || value.checked);
              option.dataset.variantOptionChosenValue = chosenValue && chosenValue.value !== 'not-selected' ? chosenValue.value : false;
            }
          }
        }

        class OptionsSelection extends HTMLElement {
          static get observedAttributes() {
            return ['variant-selection', 'disable-unavailable', 'remove-unavailable'];
          }

          static synchronize(mainOptionsSelection) {
            const mainVariantSelection = mainOptionsSelection.getVariantSelection(); // Fast return if we aren't associated with a variant selection

            if (!mainVariantSelection) return Promise.resolve(false);
            return mainOptionsSelection.getSelectedOptions().then(selectedOptions => {
              // Update all other options selects associated with the same variant ui
              const optionsSelections = document.querySelectorAll('options-selection');
              optionsSelections.forEach(optionsSelection => {
                if (optionsSelection !== mainOptionsSelection && optionsSelection.getVariantSelection() === mainVariantSelection) {
                  optionsSelection.setSelectedOptions(selectedOptions);
                }
              });
            }).then(() => true);
          }

          constructor() {
            super();
            this.style.display = '';
            this._events = [];
            this._onChangeFn = this._onOptionChange.bind(this);
            this._optionsEls = this.querySelectorAll('[data-variant-option]');
            ({
              select: this._selectOptions,
              radio: this._radioOptions
            } = getOptions(this._optionsEls));

            this._associateVariantSelection(this.getAttribute('variant-selection'));
          }

          set variantSelection(value) {
            if (value) {
              this.setAttribute('variant-selection', value);
            } else {
              this.removeAttribute('variant-selection');
            }
          }

          get variantSelection() {
            return this.getAttribute('variant-selection');
          }

          connectedCallback() {
            this._optionsEls = this.querySelectorAll('[data-variant-option]');
            ({
              select: this._selectOptions,
              radio: this._radioOptions
            } = getOptions(this._optionsEls));

            this._associateVariantSelection(this.getAttribute('variant-selection'));

            this._selectOptions.forEach(({
              option
            }) => {
              option.addEventListener('change', this._onChangeFn);

              this._events.push({
                el: option,
                fn: this._onChangeFn
              });
            });

            this._radioOptions.forEach(({
              values
            }) => {
              values.forEach(value => {
                value.addEventListener('change', this._onChangeFn);

                this._events.push({
                  el: value,
                  fn: this._onChangeFn
                });
              });
            });

            this._onOptionChange();
          }

          disconnectedCallback() {
            this._resetOptions();

            this._events.forEach(({
              el,
              fn
            }) => el.removeEventListener('change', fn));

            this._events = [];
          }

          attributeChangedCallback(name, _oldValue, newValue) {
            switch (name) {
              case 'variant-selection':
                this._associateVariantSelection(newValue);

                break;

              case 'disable-unavailable':
              case 'remove-unavailable':
                this._updateOptions(this.hasAttribute('disable-unavailable'), this.hasAttribute('remove-unavailable'));

                break;
            }
          }

          getSelectedOptions() {
            if (!this._variantSelection) return Promise.resolve(null);
            return this._variantSelection.getProduct().then(product => {
              if (!product) return null;
              return getSelectedOptions(product, this._selectOptions, this._radioOptions);
            });
          }

          getVariantSelection() {
            return this._variantSelection;
          }

          setSelectedOptions(selectedOptions) {
            setSelectedOptions(this._selectOptions, this._radioOptions, selectedOptions);
            return this._updateOptions(this.hasAttribute('disable-unavailable'), this.hasAttribute('remove-unavailable'), selectedOptions);
          }

          _associateVariantSelection(id) {
            this._variantSelection = id ? document.getElementById(id) : this.closest('variant-selection');
          }

          _updateLabels() {
            // Update any labels
            for (let i = 0; i < this._optionsEls.length; i++) {
              const optionsEl = this._optionsEls[i];
              let optionsNameEl = null;
              let {
                parentElement
              } = optionsEl;

              while (parentElement && !optionsNameEl) {
                const tmpOptionsNameEl = parentElement.querySelector('[data-variant-option-name]');

                if (tmpOptionsNameEl) {
                  optionsNameEl = tmpOptionsNameEl;
                }

                ({
                  parentElement
                } = parentElement);
              }

              if (optionsNameEl) {
                optionsNameEl.dataset.variantOptionChosenValue = optionsEl.dataset.variantOptionChosenValue;

                if (optionsEl.dataset.variantOptionChosenValue !== 'false') {
                  optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionName;
                  const optionNameValueSpan = optionsNameEl.querySelector('span');

                  if (optionNameValueSpan) {
                    optionNameValueSpan.innerHTML = optionsEl.dataset.variantOptionChosenValue;
                  }
                } else {
                  optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionChooseName;
                }
              }
            }
          }

          _resetOptions() {
            return this._updateOptions(false, false);
          }

          _updateOptions(disableUnavailableOptions, removeUnavailableOptions, selectedOptions = null) {
            if (!this._variantSelection) return Promise.resolve(false);
            return this._variantSelection.getProduct().then(product => {
              updateOptions(product, this._selectOptions, this._radioOptions, selectedOptions || getSelectedOptions(product, this._selectOptions, this._radioOptions), disableUnavailableOptions, removeUnavailableOptions);

              this._updateLabels();
            }).then(() => true);
          }

          _updateVariantSelection(product, selectedOptions) {
            if (!this._variantSelection) return;
            const variant = getVariantFromSelectedOptions(product.variants, selectedOptions);
            const isNotSelected = selectedOptions.some(option => option === 'not-selected'); // Update master select

            if (variant) {
              this._variantSelection.variant = variant.id;
            } else {
              this._variantSelection.variant = isNotSelected ? 'not-selected' : 'unavailable';
            }
          }

          _onOptionChange() {
            if (!this._variantSelection) return;

            this._variantSelection.getProduct().then(product => {
              if (!product) return;
              const selectedOptions = getSelectedOptions(product, this._selectOptions, this._radioOptions);

              this._updateOptions(this.hasAttribute('disable-unavailable'), this.hasAttribute('remove-unavailable'), selectedOptions);

              this._updateVariantSelection(product, selectedOptions);
              OptionsSelection.synchronize(this);
            });
          }

        }

        if (!customElements.get('variant-selection')) {
          customElements.define('variant-selection', VariantSelection);
        }

        if (!customElements.get('options-selection')) {
          customElements.define('options-selection', OptionsSelection);
        }


        /***/
      })

    /******/
  });
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
      /******/
    }
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
      /******/
    };
/******/
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
    /******/
  }
/******/
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
      /******/
    };
    /******/
  })();
/******/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for (var key in definition) {
/******/ 				if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
/******/
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
    "use strict";
/* harmony import */ var _pixelunion_shopify_variants_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(722);
/* harmony import */ var _pixelunion_shopify_variants_ui__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_pixelunion_shopify_variants_ui__WEBPACK_IMPORTED_MODULE_0__);


    // Section Shopify Shopify.theme editor events

    $(document)
      .on('shopify:section:reorder', function (e) {

        var $target = $(e.target);
        var $parentSection = $('#shopify-section-' + e.detail.sectionId);

        if (Shopify.theme.jsHeader.enable_overlay == true) {
          Shopify.theme.jsHeader.unload();
          Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
        }

      });

    $(document)
      .on('shopify:section:load', function (e) {

        // Shopify section as jQuery object
        var $section = $(e.target);

        // Vanilla js selection of Shopify section
        var section = document.getElementById('shopify-section-' + e.detail.sectionId);

        // Blocks within section
        var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

        var sectionObjectUrl = $section.find('[data-theme-editor-load-script]').attr('src');

        // Check classes on schema and look for js (eg. jsMap)
        for (var i = 0; i < section.classList.length; i++) {
          if (section.classList[i].substring(0, 2) === "js") {
            var triggerClass = section.classList[i];

            // Check to see if section script exists
            if (typeof Shopify.theme[triggerClass] == 'undefined') {
              // make AJAX call to load script
              Shopify.theme.loadScript(triggerClass, sectionObjectUrl, function () {
                Shopify.theme[triggerClass].init($(section));
              });
            } else {
              if (Shopify.theme[triggerClass]) {
                // console.log('Section: ' + triggerClass + ' has been loaded.')
                Shopify.theme[triggerClass].init($(section));
              } else {
                // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
              }
            }
          }
        }

        // Check classes on block element and look for js (eg. jsMap)
        if ($jsSectionBlocks.length > 0) {
          var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
            for (var i = 0; i < this.classList.length; i++) {
              if (this.classList[i].substring(0, 2) === "js") {
                var triggerClass = this.classList[i];
                var $block = $('.' + triggerClass)
                var blockUrl = $block.find('[data-theme-editor-load-script]').attr('src');

                // Check to see if section script exists
                if (typeof Shopify.theme[triggerClass] == 'undefined') {
                  // make AJAX call to load script
                  Shopify.theme.loadScript(triggerClass, blockUrl, function () {
                    Shopify.theme[triggerClass].init($block);
                  });
                } else {
                  if (Shopify.theme[triggerClass]) {
                    // console.log('Block: ' + triggerClass + ' has been loaded.')
                    Shopify.theme[triggerClass].init($(this));
                  } else {
                    // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
                  }
                }

              }
            }
          });
        }

        // Load video feature
        Shopify.theme.video.init();

        // Scrolling animations
        Shopify.theme.animation.init();

        // Initialize reviews
        Shopify.theme.productReviews.init();

        // Object Fit Images
        Shopify.theme.objectFitImages.init();

        // Infinite scrolling
        Shopify.theme.infiniteScroll.init();

        // Disclosure menus
        Shopify.theme.disclosure.enable();

        // Search
        $(document).on('click', '[data-show-search-trigger]', function () {
          Shopify.theme.jsHeader.showSearch();
        });

        $('.search-overlay__close').on('click', function () {
          Shopify.theme.jsHeader.hideSearch();
        });

        if (Shopify.theme_settings.enable_autocomplete == true) {
          Shopify.theme.predictiveSearch.init();
        }
        // Product review scroll
        Shopify.theme.productReviews.productReviewScroll();

      });


    $(document)
      .on('shopify:section:unload', function (e) {

        // Shopify section as jQuery object
        var $section = $(e.target);

        // Vanilla js selection of Shopify section
        var section = document.getElementById('shopify-section-' + e.detail.sectionId);

        // Blocks within section
        var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

        // Check classes on schema and look for js (eg. jsMap)
        for (var i = 0; i < section.classList.length; i++) {
          if (section.classList[i].substring(0, 2) === "js") {
            var triggerClass = section.classList[i];
            if (Shopify.theme[triggerClass]) {
              // console.log('Section: ' + triggerClass + ' is unloaded.')
              Shopify.theme[triggerClass].unload($(section));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
            }
          }
        }

        // Check classes on block element and look for js (eg. jsMap)
        if ($jsSectionBlocks.length > 0) {
          var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
            for (var i = 0; i < this.classList.length; i++) {
              if (this.classList[i].substring(0, 2) === "js") {
                var triggerClass = this.classList[i];
                if (Shopify.theme[triggerClass]) {
                  // console.log('Block: ' + triggerClass + ' is unloaded.')
                  Shopify.theme[triggerClass].unload($(this));
                } else {
                  // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
                }

              }
            }
          });
        }

        // Scrolling animations
        Shopify.theme.animation.unload($section);

        // QuantityBox
        Shopify.theme.quantityBox.unload($section);

        // Infinite scrolling
        Shopify.theme.infiniteScroll.unload($section);

        // Disclosure menus
        Shopify.theme.disclosure.enable();

      });

    $(document)
      .on('shopify:section:select', function (e) {

        // Shopify section as jQuery object
        var $section = $(e.target);

        // Vanilla js selection of Shopify section
        var section = document.getElementById('shopify-section-' + e.detail.sectionId);

        // Force show state when section is selected in theme editor
        for (var i = 0; i < section.classList.length; i++) {
          if (section.classList[i].substring(0, 2) === "js") {
            var triggerClass = section.classList[i];
            if (Shopify.theme[triggerClass].showThemeEditorState) {
              Shopify.theme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
            }
          }
        }

        // Predictive search
        if (Shopify.theme_settings.enable_autocomplete == true) {
          Shopify.theme.predictiveSearch.init();
        }

        if ($('.tabs').length > 0) {
          Shopify.theme.tabs.enableTabs();
        }

        if (isScreenSizeLarge() && Shopify.theme.jsHeader.enable_overlay === true) {
          Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
        }

        if ($('.block__recommended-products').length > 0) {
          var $productPage = $('.block__recommended-products').parents('.product-page');
          Shopify.theme.jsRecommendedProducts.init($productPage);
        }

      });

    $(document)
      .on('shopify:section:deselect', function (e) {

        // Shopify section as jQuery object
        var $section = $(e.target);

        // Vanilla js selection of Shopify section
        var section = document.getElementById('shopify-section-' + e.detail.sectionId);

        // Force hide state when section is selected in theme editor
        for (var i = 0; i < section.classList.length; i++) {
          if (section.classList[i].substring(0, 2) === "js") {
            var triggerClass = section.classList[i];
            if (Shopify.theme[triggerClass].showThemeEditorState) {
              Shopify.theme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
            }
          }
        }

      });

    // Block Shopify Shopify.theme editor events

    $(document)
      .on('shopify:block:select', function (e) {

        var blockId = e.detail.blockId;
        var $parentSection = $('#shopify-section-' + e.detail.sectionId);
        var $block = $('#shopify-section-' + blockId);

        if ($('.jsFeaturedPromos').length > 0) {
          Shopify.theme.jsFeaturedPromos.blockSelect($parentSection, blockId);
        }

        if ($('.jsSlideshowWithText').length > 0) {
          Shopify.theme.jsSlideshowWithText.blockSelect($parentSection, blockId);
        }

        if ($('.jsSlideshowClassic').length > 0) {
          Shopify.theme.jsSlideshowClassic.blockSelect($parentSection, blockId);
        }

        if ($('.jsTestimonials').length > 0) {
          Shopify.theme.jsTestimonials.blockSelect($parentSection, blockId);
        }

        // Sidebar collection multi-tag filter
        if ($block.hasClass('sidebar__block')) {
          var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
          if ($toggleBtn) {
            Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
          }
        }

        // Predictive search
        if (Shopify.theme_settings.enable_autocomplete == true) {
          Shopify.theme.predictiveSearch.init();
        }

        // Scrolling animations
        Shopify.theme.animation.init();

        // Object Fit Images
        Shopify.theme.objectFitImages.init();

      });

    $(document)
      .on('shopify:block:deselect', function (e) {

        var $block = $('#shopify-section-' + e.detail.blockId);

        if ($block.hasClass('sidebar__block')) {
          var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
          if ($toggleBtn) {
            Shopify.theme.jsSidebar.closeSidebarBlock($toggleBtn);
          }
        }

      });

    $(document)
      .on('shopify:block:load', function (e) {



      });

    // Document ready
    $(function () {

      var $jsSections = $('.shopify-section[class*=js]');

      // Loop through sections with js classes and load them in
      var $jsSectionNames = $jsSections.each(function () {
        for (var i = 0; i < this.classList.length; i++) {
          if (this.classList[i].substring(0, 2) === "js") {
            var triggerClass = this.classList[i];
            if (Shopify.theme[triggerClass]) {
              // console.log('Section: ' + triggerClass + ' has been loaded.')
              Shopify.theme[triggerClass].init($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
            }

          }
        }
      });

      var resizeTimer;

      // Store window width in variable
      var width = $(window).width(), height = $(window).height();

      $(window).on('resize', function (e) {

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {

          Shopify.theme.objectFitImages.calculateAspectRatio();

          if (Shopify.theme.jsHeader.header_layout === 'vertical') {
            Shopify.theme.predictiveSearch.alignVerticalSearch()
          }

          if (!isScreenSizeLarge()) {
            // When 798 or less
            Shopify.theme.mobileMenu.init();

          } else {

            // When larger than 798
            Shopify.theme.mobileMenu.unload();
          }

        }, 250);

      });

      //Enable plyr
      Shopify.theme.video.init();

      // Predictive search
      if (Shopify.theme_settings.enable_autocomplete == true) {
        Shopify.theme.predictiveSearch.init();
      }

      Shopify.theme.dropdownMenu();

      Shopify.theme.disclosure.enable();

      // Scrolling animations
      Shopify.theme.animation.init();

      // QuantityBox
      Shopify.theme.quantityBox.init();

      /* Show associated variant image on hover */
      if (Shopify.theme_settings.show_collection_swatches == true) {
        Shopify.theme.thumbnail.enableSwatches();
      }

      /* Show secondary image on hover */
      if (Shopify.theme_settings.show_secondary_image == true) {
        Shopify.theme.thumbnail.showVariantImage();
      }

      // Quick shop
      if (Shopify.theme_settings.enable_quickshop) {
        Shopify.theme.thumbnail.showQuickShop();
      }

      // Currency converter
      if (Shopify.theme.currencyConverter) {
        Shopify.theme.currencyConverter.init();
      }

      //Infinite scrolling
      if ($('[data-custom-pagination]').length) {
        Shopify.theme.infiniteScroll.init();
      }

      //Select event for native multi currency checkout
      //   $('.shopify-currency-form select').on('change', function () {
      //     $(this)
      //       .parents('form')
      //       .submit();
      //   });

      $('.shopify-currency-form ul li').on('click', function () {
        $(this)
          .parents('form')
          .submit();
      });


      // Tabs
      if ($('.tabs').length > 0) {
        Shopify.theme.tabs.enableTabs();
      }

      // Additional checkout buttons
      if (!isScreenSizeLarge()) {
        $('.additional-checkout-buttons').addClass('additional-checkout-buttons--vertical');
      }

      // Accordion
      if ($('.accordion, [data-cc-accordion]').length > 0) {
        Shopify.contentCreator.accordion.init();
      }

      // Backwards compatiblity for Flexslider
      if ($('.slider, .flexslider').length > 0) {
        Shopify.contentCreator.slideshow.init();
      }

      // Object Fit Images
      Shopify.theme.objectFitImages.init();

      // Responsive Video
      Shopify.theme.responsiveVideo.init();

      // Flickity IOS Fix
      Shopify.theme.flickityIosFix();

      // Product review scroll
      Shopify.theme.productReviews.productReviewScroll();

    });

    /*============================================================================
    Slideshow arrows
    ==============================================================================*/

    if (Shopify.theme_settings.icon_style == 'icon_solid') {
      window.arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';
    } else {
      window.arrowShape = 'M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z';
    }


    $(document).on('click', '.js-recover-password', function () {
      $('.login__title').text('Password Reset');
      $('.custom-loginpage header.container p').text('Give us your email and we will send you a link to reset your password');
    });

    $(document).on('click', '.cancel-recover-password', function () {
      $('.login__title').text('SIGN IN');
      $('.custom-loginpage header.container p').html('Don’t have an account? <a href="/account/register" class="hoverButton">Create an account</a>');
    });

    $('.visit-our-stores-slider').flickity({
      cellAlign: 'left',
      imagesLoaded: true,
      contain: true,
      pageDots: false,
      arrowShape: arrowShape
    });

    $(document).on('click', '.accordion', function () {
      if ($(this).hasClass("active")) {
        $('.visit-our-stores-faq .accordion').removeClass("active");
        $('.visit-our-stores-faq .panel').removeClass("active1");
        $('.accordion .accordion-icon').text('+');
      } else {
        $('.visit-our-stores-faq .accordion').removeClass("active");
        $('.visit-our-stores-faq .panel').removeClass("active1");
        $('.accordion .accordion-icon').text('+');

        $(this).addClass("active");
        $(this).next().addClass("active1");
        $('.accordion.active .accordion-icon').text('-');
      }
    });

    $(document).on('click', '.accordion', function () {
      var index_id = $(this).data("index-id");
      var click_count = parseInt($('.visit-our-stores-column img[data-index-id="' + index_id + '"]').data("index-id"));
      var totle = click_count - 1;
      $('.visit-our-stores-slider').flickity('select', totle);
    });


    $('.custom-faq-related-content[data-heading-name!="category_1"]').hide();

    $('.custom-faq-related-heading-content').on('click', function () {
      $('.custom-faq-related-heading-content.active').removeClass('active');
      $(this).addClass('active');
      var faq_type = $(this).data('heading-name');
      $('.custom-faq-related-content').hide();
      $('.custom-faq-related-content[data-heading-name="' + faq_type + '"]').show();
    });

    $('.custom-faq-related-content').on('click', function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');

      } else {
        $(this).addClass('active');
      }
    });

    $('.custom-our-brand-cat-buttons').on('click', function () {
      $('.custom-our-brand-cat-buttons').removeClass("cat-button-active");
      $(this).addClass("cat-button-active");
      var tag = $(this).data("tag");
      tag = tag.replaceAll(' ', '_').replaceAll('+', '_').toLowerCase();
      if (tag != 'all') {
        $('.custom-our-brand-column').hide();
        $('.custom-our-brand-column[data-tag=' + tag + ']').show();
      } else {
        $('.custom-our-brand-column').show();
      }

    });

    if ($('.custom-our-brand-cat-buttons').length > 0) {
      var longs = $('.custom-our-brand-cat-buttons').length;
      for (var j = 0; j < longs; j++) {
        var tag = $($('.custom-our-brand-cat-buttons')[j]).data('tag');
        tag = tag.replaceAll(' ', '_').replaceAll(' ', '+').toLowerCase();
        $($('.custom-our-brand-cat-buttons[data-tag="' + tag + '"]')).hide();
        $($('.custom-our-brand-cat-buttons[data-tag="' + tag + '"]')[0]).show();
      }
    }

    // $(document).on('click','.custom-our-brand-back',function(){
    //   var backscroll = $('.custom-our-brand-cat-menu-row').scrollLeft()-150;

    //   if($('.custom-our-brand-cat-menu-row').scrollLeft() == 0) {
    //     $('.custom-our-brand-cat-menu-row').scrollLeft(backscroll);
    //     $('.custom-our-brand-back').hide();
    //   }else{
    //     $('.custom-our-brand-cat-menu-row').scrollLeft(backscroll);
    //     $('.custom-our-brand-next').show();
    //   }

    // });

    // $(document).on('click','.custom-our-brand-next',function(){
    //   var nextscroll = $('.custom-our-brand-cat-menu-row').scrollLeft()+150;
    //   var total_width=$('.custom-our-brand-cat-buttons').innerWidth()*$('.custom-our-brand-cat-buttons').length;
    //   var current_width=$('.custom-our-brand-cat-menu-row').innerWidth()+$('.custom-our-brand-cat-menu-row').scrollLeft();
    //   var next_width=current_width+$('.custom-our-brand-cat-buttons').innerWidth();
    //   if(next_width<total_width) {
    //     $('.custom-our-brand-cat-menu-row').scrollLeft(nextscroll);
    //     $('.custom-our-brand-back').show();
    //     $('.custom-our-brand-next').show();
    //   }else{
    //     $('.custom-our-brand-next').hide();
    //   }
    // });

    $('.custom-about-us-4-0-column-slider.slider-active').flickity({
      cellAlign: 'left',
      contain: true,
      imagesLoaded: true,
      wrapAround: true,
      groupCells: 1,
      pageDots: false,
      adaptiveHeight: true
    });

    $(document).on('click', '.custom-about-us-4-0-button', function () {
      $('.custom-about-us-4-0-button').removeClass("button-active");
      $(this).addClass("button-active");
      var tag = $(this).data('tag');
      $('.custom-about-us-4-0-hide').removeClass("row2-active");
      $('.custom-about-us-4-0-hide[data-tag="' + tag + '"]').addClass("row2-active");

      var $carousel = $('.custom-about-us-4-0-hide[data-tag="' + tag + '"] .custom-about-us-4-0-column-slider.slider-active').flickity();
      $carousel.flickity('resize');

    });


    $('.custom-about-5-0 .gallery__wrapper').flickity({
      contain: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: true,
      imagesLoaded: true,
      arrowShape: arrowShape,
      autoPlay: 5000,
      wrapAround: true
    });


    $(document).on('click', '.custom-blog_filter-next', function () {
      var nextscroll = $('.custom-blog_filter .select2').scrollLeft() + 150;
      var total_width = $('.custom-blog_filter .select2 a').innerWidth() * $('.custom-blog_filter .select2 a').length;
      var current_width = $('.custom-blog_filter .select2').innerWidth() + $('.custom-blog_filter .select2').scrollLeft();
      var next_width = current_width + $('.custom-blog_filter .select2 a').innerWidth();
      if (next_width < total_width) {
        $('.custom-blog_filter .select2').scrollLeft(nextscroll);
        $('.custom-blog_filter-back').show();
        $('.custom-blog_filter-next').show();
      } else {
        $('.custom-blog_filter-next').hide();
      }
    });


    $(document).on('click', '.custom-blog_filter-back', function () {
      var backscroll = $('.custom-blog_filter .select2').scrollLeft() - 150;

      if ($('.custom-blog_filter .select2').scrollLeft() == 0) {
        $('.custom-blog_filter .select2').scrollLeft(backscroll);
        $('.custom-blog_filter-back').hide();
      } else {
        $('.custom-blog_filter .select2').scrollLeft(backscroll);
        $('.custom-blog_filter-next').show();
      }
    });


    $('.custom-subscribe-slider-column2').flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      imagesLoaded: true,
      groupCells: true,
      arrowShape: arrowShape
    });
    // $('.gift-guide--slider-column2.left').flickity({
    //   // cellAlign: 'left',
    //   contain: true,
    //   pageDots: false,
    //   imagesLoaded: true,
    //   groupCells: true,
    //   arrowShape: arrowShape
    // });
    // $('.gift-guide--slider-column2.right').flickity({
    //   // cellAlign: 'right',
    //   contain: true,
    //   pageDots: false,
    //   imagesLoaded: true,
    //   groupCells: true,
    //   arrowShape: arrowShape,
    //   initialIndex: $(this).attr("data-size")
    // });
    $(document).on('click', '.subscribe-button', function () {
      var id = $(this).next().val();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: id
        },
        dataType: 'json',
        success: function (data) {
          var $el = $('[data-ajax-cart-trigger]');
          if (window.innerWidth < 768) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);

          }

          $el.addClass('show-mini-cart');
          Shopify.theme.jsAjaxCart.addGift();
          Shopify.theme.jsAjaxCart.updateView();
        }
      });
    });

       $(document).on('click', '.cart-btn', function (e) {
        e.preventDefault();
      var id = $(this).next().val();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: id
        },
        dataType: 'json',
        success: function (data) {
          var $el = $('[data-ajax-cart-trigger]');
          if (window.innerWidth < 768) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);

          }

          $el.addClass('show-mini-cart');
          Shopify.theme.jsAjaxCart.addGift();
          Shopify.theme.jsAjaxCart.updateView();
        }
      });
    });

    $(document).on('click', '.about-5-0-img-Collection-row-button', function () {
      $('.about-5-0-img-Collection-row-button').removeClass("button-active");
      $(this).addClass("button-active");
      var row_id = $(this).data('row-id');

      $('.about-5-0-img-Collection-row').removeClass("row-active");
      $('.about-5-0-img-Collection-row[data-row-id=' + row_id + ']').addClass("row-active");
    });


    $('.custom-home-gallery .gallery-type--classic').flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      imagesLoaded: true,
      groupCells: true,
      arrowShape: arrowShape
    });


    if ($(window).width() < 769) {

    }
    else {
      $('.custom-home-gallery-slider .gallery__wrapper').flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        imagesLoaded: true,
        arrowShape: arrowShape
      });
    }


    if ($('.beauty-bar-service-tags').length > 0) {
      var longs = $('.beauty-bar-service-tags').length;
      for (var j = 0; j < longs; j++) {
        var tag = $($('.beauty-bar-service-tags')[j]).data('tag');

        $($('.beauty-bar-service-tags[data-tag="' + tag + '"]')).hide();
        $($('.beauty-bar-service-tags[data-tag="' + tag + '"]')[0]).show();
      }
    }

    if ($('.beauty-bar-service-tags').length > 0) {
      var tag = $($('.beauty-bar-service-tags')[0]).data('tag');

      $($('.beauty-bar-service-product[data-tag="' + tag + '"]')).addClass("beauty-bar-service-product-active");
    }


    $('.beauty-bar-service-tags').on('click', function () {
      $('.beauty-bar-service-tags').removeClass("c2-service-tag-active");
      $(this).addClass("c2-service-tag-active");
      var tag = $(this).data("tag");

      $('.beauty-bar-service-product').removeClass("beauty-bar-service-product-active");
      $('.beauty-bar-service-product[data-tag="' + tag + '"]').addClass("beauty-bar-service-product-active");

    });



    $(document).on('click', '.collection-menu-next', function () {
      var doc = $('.collection-menu-row')[0];
      var scroll_left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
      var nextscroll = scroll_left + 170;
      var total_width = 0;
      for (j = 0; j < ($('.collection-menu-row a').length - 2); j++) {
        total_width = total_width + $($('.collection-menu-row a')[j]).innerWidth();
      }
      if (scroll_left < total_width) {
        $('.collection-menu-row').scrollLeft(nextscroll);
        $('.collection-menu-back').show();
        $('.collection-menu-next').show();
        nextscroll = scroll_left + 170;
        if (nextscroll > total_width) {
          $('.collection-menu-next').hide();
        }
      } else {
        $('.collection-menu-next').hide();
      }
    });

    $(document).ready(function () {
      if (window.location.href.includes('collection')) {
        var total_number = $('.collection-menu-row a').length;
        var single_length = $('.collection-menu-row a').innerWidth();
        var total_width = 0;
        for (j = 0; j < ($('.collection-menu-row a').length); j++) {
          total_width = total_width + $($('.collection-menu-row a')[j]).innerWidth();
        }
        if (total_width > $(window).innerWidth()) {
          $('.collection-menu-next').show();
        } else {
          $('.collection-menu-next').hide();
        }
      }
    });

    $(document).on('click', '.collection-menu-back', function () {

      var doc = $('.collection-menu-row')[0];
      var scroll_left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
      var backscroll = $('.collection-menu-row').scrollLeft() - 170;
      // debugger
      if (scroll_left < 180) {
        $('.collection-menu-row').scrollLeft(backscroll);
        $('.collection-menu-back').hide();

      } else {
        $('.collection-menu-row').scrollLeft(backscroll);
        $('.collection-menu-next').show();

      }

    });


    $('.store-locations-menu-button').on('click', function () {
      var data_tag = $(this).data('tag');
      $('.menu-button-active').removeClass('menu-button-active');
      $(this).addClass('menu-button-active');
      $('.store-locations-container-map').removeClass('row-active');
      $('.store-locations-address-container').removeClass('row-active');
      $('.store-locations-container-map[data-tag="' + data_tag + '"]').addClass('row-active');
      $('.store-locations-address-container[data-tag="' + data_tag + '"]').addClass('row-active');
    })
    $('.alphabetFilterBtn').on('click', function () {
      var tag = $(this).data('tag');
      $(".allBtn").click();
      $(".alphabetFilterBtn").removeClass("alphabetFilterBtn-active");
      $(this).addClass("alphabetFilterBtn-active");
      if (tag != "all") {
        $(".custom-our-brand-column").hide();
        $('a[data-firstLetter="' + tag + '"]').show();
      }
      else {
        $(".custom-our-brand-column").show();
      }


    });
    $('.glossary-button').on('click', function () {
      var tag = $(this).data('tag');
      $('.custom-glossary-faq dt').hide();
      $('.glossary-button').removeClass('glossary-button-active');
      $(this).addClass('glossary-button-active');
      if (tag == 'all') {
        for (j = 0; j < $('.custom-glossary-faq dt').length; j++) {
          $($('.custom-glossary-faq dt')[j]).show();
        }
      } else {
        for (j = 0; j < $('.custom-glossary-faq dt').length; j++) {
          if ($($('.custom-glossary-faq dd')[j]).css('display') == 'block') {
            $($('.custom-glossary-faq dt button')[j]).click();
          }
          var faq_name = $($('.custom-glossary-faq dt')[j]).find('button').data('tag-name');
          var first_letter = faq_name.slice('0', '1').toLowerCase();
          if (first_letter == tag) {
            $($('.custom-glossary-faq dt')[j]).show();
          }
        }
      }
      $('.glossary-show-all').removeClass('glossary-show-all');
      show_glossary_button();
    });
    function show_glossary_button() {
      var total_number = $('.custom-glossary-faq dt:visible').length;
      var total_height = $($('.custom-glossary-faq dt')[0]).height() + 48;
      total_height = total_number * total_height;
      if (total_height > 600) {
        $('.custom-glossary-button button').show();
      } else {
        $('.custom-glossary-button button').hide();
      }
    }
    $(document).on('click', '.facelet-filters-text.select', function () {
      $('.collection__filters-popup').toggle();
    });

    $('.custom-glossary-button').on('click', function () {
      $('section.section.custom-glossary-faq .faq-accordion').addClass('glossary-show-all');
      $('.custom-glossary-button button').hide();
    });
    $(document).mouseup(function (e) {
      var container = $(".collection__filters-popup");
      var container2 = $('.facelet-filters-text.select');
      if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
        container.hide();
      }
    });
    $(document).ready(function () {
      if (window.innerWidth << 768) {

        $('.mobile-menu__first-level .close-dropdown').on('click', function () {

          if (!$(this).parent().hasClass('c2-header-open')) {
            $('.mobile-menu__first-level .close-dropdown').parent().hide();
            $(this).parent().addClass('c2-header-open');
            $(this).parent().show();
          } else {
            $('.mobile-menu__first-level .close-dropdown').parent().show();
            $(this).parent().removeClass('c2-header-open');
          }
        });
      }
    })


    // $('.custom-home-gallery-heading .rich-text__text p span:nth-child(1)').on('click',function(){
    //   if($('.block1-for-all-product').hasClass("product-button-active")){
    //     $('.block1-for-all-product').removeClass("product-button-active");
    //   }else{
    //     $('.block1-for-all-product').addClass("product-button-active");
    //     $('.block2-for-all-product').removeClass("product-button-active");
    //   }
    // });

    $(".custom-home-gallery-heading .rich-text__text p span:nth-child(1)").hover(function () {
      $('.block1-for-all-product').addClass("product-button-active");
    });

    var hovering = false;
    $(".custom-home-gallery-heading .rich-text__text p span:nth-child(1)").mouseleave(function () {
      setTimeout(() => {
        if (!hovering) {
          $('.block1-for-all-product').removeClass("product-button-active");
        }
      }, 200);
    });

    $(document).on('mouseenter', ".block1-for-all-product.product-button-active", function () {
      hovering = true;
    });
    $(document).on('mouseleave', '.block1-for-all-product.product-button-active', function (e) {
      hovering = false;
      $('.block1-for-all-product').removeClass("product-button-active");
    });

    $('.block1-for-all-product .block1-for-all-product-button').on('click', function (e) {
      e.preventDefault();

      var collection_handle = $(this).data('collection-handle');
      $('.block2-for-all-product a.block1-for-all-product-button').hide();
      $('.block2-for-all-product a.block1-for-all-product-button.c2-' + collection_handle).show();
      $('.custom-home-gallery-heading .rich-text__text p span:nth-child(1)').text($(this).text());
      $('.block1-for-all-product').removeClass("product-button-active");
      var total_width = $('section.section.custom-home-gallery-heading .rich-text__text').outerWidth() + 'px';
      var dropdown_width = $('.block2-for-all-product').outerWidth();
      var dropdown_width1 = $('.block1-for-all-product').outerWidth();
      var width1 = ($('section.section.custom-home-gallery-heading .rich-text__text').outerWidth() / 2) - (dropdown_width1 / 2) - 30;
      if (window.innerWidth > 768) {
        $('.block2-for-all-product').css('left', 'calc( ' + total_width + ' - 130px)');
        $('.block1-for-all-product').css('left', width1 + 'px');

      } else {
        if ($('section.section.custom-home-gallery-heading .rich-text__text p').innerHeight() > 30) {
          $('.block2-for-all-product').css('top', '110px');
          $('.block1-for-all-product').css('left', '29%');
          $('.block2-for-all-product').css('left', '29%');
        }

      }
    });

    // $(document).on('mouseleave','.block1-for-all-product.product-button-active',function(e){
    //    $('.block1-for-all-product').removeClass("product-button-active");
    // });



    $(".custom-home-gallery-heading .rich-text__text p span:nth-child(3)").hover(function () {
      $('.block2-for-all-product').addClass("product-button-active");
    });


    var hovering1 = false;
    $(".custom-home-gallery-heading .rich-text__text p span:nth-child(3)").mouseleave(function () {
      setTimeout(() => {
        if (!hovering1) {
          $('.block2-for-all-product').removeClass("product-button-active");
        }
      }, 200);
    });

    $(document).on('mouseenter', ".block2-for-all-product.product-button-active", function () {
      hovering1 = true;
    });
    $(document).on('mouseleave', '.block2-for-all-product.product-button-active', function (e) {
      hovering1 = false;
      $('.block2-for-all-product').removeClass("product-button-active");
    });

    $(document).ready(function () {
      if (window.location.href == 'https://kerwellness.com/pages/beauty-bar') {
        $('.custom-beauty-bar-faq dt:nth-child(1) .accordion__button').click();
      }
    });
    function percentage(percent, total) {
      return ((percent / 100.00) * total).toFixed(2)
    }
    function rc_widget_update() {
      setTimeout(function () {
        var product_price = $('.rc-radio__price').text().trim().split('$');
        var product_price_2 = parseFloat(product_price[1]).toFixed(2);
        var product_price_off = (product_price_2 - parseFloat(product_price[2]).toFixed(2)).toFixed(2);
        var product_recurring_price_off = percentage(10, product_price_2);
        var product_annual_price_off = parseFloat(product_recurring_price_off * 12.00).toFixed(2);
        var total = ["Free mini gift included with each subscription delivery", "Easily cancel anytime", "Save $3.60 on each order ($36.20 annually)"];
        total[2] = "Save $"+product_price_off+" on your first order then $"+product_recurring_price_off+" on each next order ($" + product_annual_price_off + " annually)";
        $('.rc-selling-plans-single').remove();
        if (total.length == 3) {
          for (var j = 0; j < total.length; j++) {
            $('.rc-selling-plans').append('<span class="rc-selling-plans-single">' + total[j] + '</span>')
          }
        }

      }, 300);
      var save_text = $('.rc-radio__subscription').text().split('_split_')[1];
      var save_price = $('.rc-radio__price').text();
      // Read original price from compare-at-price element (not the cosmetic price)
      var compareAtPriceEl = $('.modal_price.subtitle [data-compare-at-price] .money');
      var original_price = '';
      if (compareAtPriceEl.length > 0) {
        original_price = compareAtPriceEl.text().split('USD')[0].trim();
      } else {
        // Fallback: try to read from compare-at-price directly
        var compareAtText = $('.modal_price.subtitle [data-compare-at-price]').text();
        if (compareAtText) {
          original_price = compareAtText.split('USD')[0].trim();
        } else {
          // Last fallback: use main price (shouldn't happen)
          original_price = $('.modal_price.subtitle .price .money').text().split('USD')[0].trim();
        }
      }

      if (save_text != undefined) {
        $('.rc-radio__price').remove();
        $('.rc-radio__subscription').text($('.rc-radio__subscription').text().split('_split_')[0]);
        $($('.rc-radio__label')[0]).append('<span class="rc-radio__price"><span class="rc_save_text">' + save_text + '</span><span class="rc-final-price-container"><span class="rc_c2_original_price">' + original_price + '</span><span class="rc_c2_new_price">' + save_price + '</span></span></span>');
      }
      
      // Update one-time purchase option to show cosmetic price
      updateOneTimePurchasePrice();

    }
    
    // Function to update one-time purchase price with cosmetic price
    function updateOneTimePurchasePrice() {
      var cosmeticPrice = $('.modal_price.subtitle [data-price] .money').first().text().split('USD')[0].trim();
      if (!cosmeticPrice) return;
      
      // Update one-time purchase label/price - be very aggressive
      $('label.rc-radio:not(.subscription-radio)').each(function() {
        var $label = $(this);
        
        // Try multiple selectors to find price elements
        var $priceEl = $label.find('.rc-radio__price').not('.rc-final-price-container');
        var $moneyEl = $priceEl.find('.money');
        var $labelContent = $label.find('.rc-radio__label');
        
        // Update .money elements directly
        if ($moneyEl.length > 0) {
          $moneyEl.each(function() {
            var $el = $(this);
            var currentText = $el.text().trim();
            // Only update if it's not already the cosmetic price
            if (currentText !== cosmeticPrice && currentText.match(/\$[\d,]+\.?\d*/)) {
              $el.text(cosmeticPrice);
            }
          });
        }
        
        // Update price element text
        if ($priceEl.length > 0) {
          $priceEl.each(function() {
            var $el = $(this);
            var currentText = $el.text();
            if (currentText.match(/\$[\d,]+\.?\d*/) && !currentText.includes(cosmeticPrice)) {
              $el.html($el.html().replace(/\$[\d,]+\.?\d*/g, cosmeticPrice));
            }
          });
        }
        
        // Update label content
        if ($labelContent.length > 0) {
          $labelContent.each(function() {
            var $el = $(this);
            var currentText = $el.text();
            if (currentText.match(/\$[\d,]+\.?\d*/) && !currentText.includes(cosmeticPrice)) {
              $el.html($el.html().replace(/\$[\d,]+\.?\d*/g, cosmeticPrice));
            }
          });
        }
        
        // Last resort: update entire label
        var labelText = $label.text();
        if (labelText.match(/\$[\d,]+\.?\d*/) && !labelText.includes(cosmeticPrice)) {
          $label.html($label.html().replace(/\$[\d,]+\.?\d*/g, cosmeticPrice));
        }
      });
    }
    
    // Continuous monitoring - brute force approach for temporary theme
    var rechargePriceInterval = null;
    
    function startContinuousMonitoring() {
      // Clear any existing interval
      if (rechargePriceInterval) {
        clearInterval(rechargePriceInterval);
      }
      
      // Check and update every 300ms
      rechargePriceInterval = setInterval(function() {
        updateOneTimePurchasePrice();
      }, 300);
    }
    
    function stopContinuousMonitoring() {
      if (rechargePriceInterval) {
        clearInterval(rechargePriceInterval);
        rechargePriceInterval = null;
      }
    }
    
    // Try multiple times with increasing delays to catch PriceUI updates
    function updateOneTimePurchasePriceWithRetries() {
      var delays = [100, 200, 400, 600, 1000, 1500];
      delays.forEach(function(delay) {
        setTimeout(function() {
          updateOneTimePurchasePrice();
        }, delay);
      });
    }

    $(document).ready(function () {
      setTimeout(function () {
        rc_widget_update();
        // Start continuous monitoring after widget loads
        setTimeout(function() {
          startContinuousMonitoring();
        }, 1500);
      }, 1000);
    });

    $(document).on('click', 'label.rc-radio.subscription-radio', function () {
      rc_widget_update();
    });
    
    // Update one-time purchase price when one-time button is clicked
    $(document).on('click', 'label.rc-radio:not(.subscription-radio)', function () {
      updateOneTimePurchasePriceWithRetries();
    });
    
    // Listen for variant changes to update one-time purchase price
    document.addEventListener('variant-change', function() {
      updateOneTimePurchasePriceWithRetries();
      // Restart continuous monitoring to ensure it keeps working
      setTimeout(function() {
        startContinuousMonitoring();
      }, 500);
    });

    $('.store-locations-menu-sub-row').flickity({
      pageDots: false,
      imagesLoaded: true,
      groupCells: true
    });
    $(document).ready(function () {
      setTimeout(function () {
        if (window.location.search == '?customer_posted=true' && window.location.hash == '#contact_form') {
          $('.newsletter-section.custom-home-newsletter')[0].scrollIntoView();
        }
      }, 1000);
    });



    $(document).ready(function () {
      setTimeout(function () {
        if (window.location.pathname == '/pages/store-locations') {
          var url = window.location.hash.replace('#', '').toLowerCase();

          $('.store-locations-menu-button[data-tag="' + url + '"]').click();
        }
      }, 1000);
      if (window.location.pathname == '/pages/store-locations') {
        $(window).on('hashchange', function (e) {
          var url = window.location.hash.replace('#', '').toLowerCase();

          $('.store-locations-menu-button[data-tag="' + url + '"]')[0].scrollIntoView({
            behavior: "smooth", // or "auto" or "instant"
            block: "center" // or "end"
          });
          $('.store-locations-menu-button[data-tag="' + url + '"]').click();

        });
      }


      var t = setInterval(function(){
        console.log("t");
        if(jQuery('.rc-widget').length > 0 ){
          jQuery('.first_subscription').show();  
          clearInterval(t);
        }else{ 
          jQuery('.first_subscription').hide();
        }
      }, 1000);
      
      setTimeout(function () {
        clearInterval(t);
        console.log("tt");
      },50000);
      

      
    });





    

    

    $('.custom-our-brand-cat-menu-row').flickity({
      cellAlign: 'left',
      contain: true,
      imagesLoaded: true,
      pageDots: false,
      groupCells: true,
      arrowShape: arrowShape
    });

    // $(document).on('click','.rc-widget label',function(){
    //     let c_new_price=$(this).text().split(' ')[$(this).text().split(' ').length-1];
    //     $('.custom-product-form .price .money').text(c_new_price+' USD');
    // });


  })();

  /******/
})()
  ;